import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[30px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = { class: "absolute -bottom-[10px] ltr:right-0 rtl:left-0 max-w-[125px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex items-center gap-[12px]\"><div class=\"bg-purple-600 rounded-[4px] text-white w-[44px] h-[44px] flex items-center justify-center\"><i class=\"material-symbols-outlined\"> person_add </i></div><div><span class=\"block\"> New Employees </span><h5 class=\"mb-0 mt-[2px] text-[20px] font-semibold\">8,24</h5></div></div><div class=\"mt-[32px] flex items-center gap-[7px]\"><div class=\"bg-success-100 text-success-700 rounded-[4px] w-[26px] h-[26px] flex items-center justify-center text-[18px]\"><i class=\"ri-arrow-right-up-line\"></i></div><div class=\"text-gray-600 dark:text-gray-400\"><span class=\"font-medium text-gray-700 dark:text-gray-400\">+10%</span> last year </div></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "radialBar",
              height: "140",
              options: _ctx.newEmployees,
              series: _ctx.employees
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}